// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "Enter title...",
    titleHelp: "Optional heading to display above the content",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and content",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "Skriv inn tittel...",
    titleHelp: "Valgfri overskrift som vises over innholdet",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og innholdet",
  },
} as const;
